// Interim constants for the RecoveryAI Activation surface (WP7).
//
// The activation / billing / credit backend does not exist yet (no
// `PUT recovery/configuration/activation`, no `available_credit` field). These
// values come from the approved product copy and are wired FE-side until the real
// contract lands. Numeric values are extracted to named constants per the CLAUDE.md
// "no magic numbers" rule.

import { RECOVERY_AI_TERMS_PATH } from 'constants/policyDoc'

// $250 promotional credit pre-loaded on every new account ("getting started is on us").
export const PROMO_CREDIT_CENTS = 25000

// $0 — escalated cases are handed off to the merchant's team at no charge.
export const ESCALATION_CENTS = 0

// $0.25 per resolved case / $2.25 per recovered guest — the RecoveryAI per-event
// rates. (Sum $2.50/successful recovery.)
export const PER_RESOLUTION_CENTS = 25
export const PER_RECOVERY_CENTS = 225

// Marketing figure derived from the rate constants (guarded in constants.test.ts) so
// the "N guest recoveries" copy on the success page and in the pricing modal's credit
// panel can never drift from the per-event rates.
// Math.floor, not bare division: this figure is rendered as a whole number on two
// money surfaces ("your first N guest recoveries"), and a rate change that makes the
// division non-integral would otherwise print something like 96.15.
export const RECOVERIES_COUNT = Math.floor(
  PROMO_CREDIT_CENTS / (PER_RESOLUTION_CENTS + PER_RECOVERY_CENTS)
)

// Inline legal link in the activation agreement paragraph, pointing at the
// static RecoveryAI Terms of Service page.
export const ACTIVATION_AGREEMENT_LINKS = {
  serviceTerms: RECOVERY_AI_TERMS_PATH,
}
